import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const AnalyticsPage = lazy(() => import('./AnalyticsPage'));

export const analyticsRoutes: RouteObject[] = [
  {
    path: 'analytics',
    element: (
      <ProtectedRoute action="dashboard:analytics">
        <AnalyticsPage />
      </ProtectedRoute>
    ),
  },
];
